import React from "react";

function MusicPlayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g
        id="Group_23758"
        data-name="Group 23758"
        transform="translate(0.094 0.297)"
      >
        <circle
          id="Ellipse_2005"
          data-name="Ellipse 2005"
          cx="14"
          cy="14"
          r="14"
          transform="translate(-0.094 -0.297)"
          fill="#181818"
        />
        <path
          id="Path_13343"
          data-name="Path 13343"
          d="M18.438,11.758,8.713,18.241A.459.459,0,0,1,8,17.859V4.893a.459.459,0,0,1,.713-.382l9.725,6.483a.459.459,0,0,1,0,.763Z"
          transform="translate(2.546 2.458)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default MusicPlayIcon;
